import { useEffect, useRef, useState } from "react";

/** Reveal-on-scroll wrapper. Content is never left hidden: it also reveals after a short fallback. */
const ScrollReveal = ({ children, delay = 0, direction = "up", className = "", style = {} }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return undefined;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.07, rootMargin: "0px 0px -32px 0px" }
    );
    observer.observe(el);
    // Crawlers and screenshot tools don't scroll; make sure nothing stays invisible for long.
    const fallback = setTimeout(() => setVisible(true), 1500);
    return () => {
      observer.disconnect();
      clearTimeout(fallback);
    };
  }, []);

  const dirClass = direction !== "up" ? ` reveal-${direction}` : "";

  return (
    <div
      ref={ref}
      className={`scroll-reveal${visible ? " scroll-reveal--in" : ""}${dirClass}${className ? ` ${className}` : ""}`}
      style={{ transitionDelay: `${delay}ms`, ...style }}
    >
      {children}
    </div>
  );
};

export default ScrollReveal;
